module.exports = __webpack_public_path__ + "static/img/pic_koll@2x.3860448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/socialPlatform/pic_koll@2x.png
// module id = HgLV
// module chunks = 0